import React from "react";
import styled from "styled-components";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/fontawesome-free-solid";
import { faSmile } from "@fortawesome/fontawesome-free-solid";
import { faStar } from "@fortawesome/fontawesome-free-solid";
import { faPeopleCarry } from "@fortawesome/fontawesome-free-solid";

const About = () => {
  return (
    <AboutWrapper id="about">
      <AboutText>
        <AboutSentence>nobis dolorem sapiente evenie.</AboutSentence>
        <AboutTitle>About Us</AboutTitle>
        <AboutContent>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum
          sunt, unde aperiam aliquid quia repudiandae, ex harum quis amet
          delectus maxime, tempora possimus aut laboriosam magni corrupti
          labore. Doloremque, sit?
        </AboutContent>
        <AboutRead>Read More...</AboutRead>
      </AboutText>
      <AboutNumbers>
        <AboutNumbersMain>
          <Icon>
            <FontAwesomeIcon icon={faCalendar} />
          </Icon>
          <AboutNumbersText>
            <h2>15+</h2>
            <h3>onsectetur perspiciatis</h3>
          </AboutNumbersText>
        </AboutNumbersMain>
        <AboutNumbersMain>
          <Icon>
            <FontAwesomeIcon icon={faStar} />
          </Icon>
          <AboutNumbersText>
            <h2>3434+</h2>
            <h3>onsectetur perspiciatis</h3>
          </AboutNumbersText>
        </AboutNumbersMain>
        <AboutNumbersMain>
          <Icon>
            <FontAwesomeIcon icon={faSmile} />
          </Icon>
          <AboutNumbersText>
            <h2>125+</h2>
            <h3>onsectetur perspiciatis</h3>
          </AboutNumbersText>
        </AboutNumbersMain>
        <AboutNumbersMain>
          <Icon>
            <FontAwesomeIcon icon={faPeopleCarry} />
          </Icon>
          <AboutNumbersText>
            <h2>80+</h2>
            <h3>onsectetur perspiciatis</h3>
          </AboutNumbersText>
        </AboutNumbersMain>
      </AboutNumbers>
    </AboutWrapper>
  );
};

const AboutWrapper = styled.div`
  width: 100vw;
  height: 50vh;
  background-color: whitesmoke;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  padding-top: 10vh;

  @media screen and (orientation: portrait) {
    flex-direction: column;
    height: 125vh;
    padding-top: 0;
  }
`;

const AboutText = styled.div`
  width: 35vw;
  height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  transform: translateX(7.5vw);
  overflow: hidden;

  @media screen and (orientation: portrait) {
    width: 100vw;
    transform: translateX(7.5vw);
  }
`;

const AboutSentence = styled.h1`
  margin: 0;
  max-width: 35vw;
  font-size: 0.85vw;
  color: gray;
  opacity: 0.6;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 1.75vh;
  }
`;

const AboutTitle = styled.div`
  max-width: 35vw;
  margin: 0;
  font-size: 2vw;
  color: black;
  font-weight: 600;

  @media screen and (orientation: portrait) {
    max-width: 100vw;
    font-size: 4.25vh;
  }
`;

const AboutContent = styled.h1`
  margin: 0;
  max-width: 25vw;
  color: gray;
  font-weight: 300;
  font-size: 1.4vw;
  justify-content: left;
  margin-top: 1vh;
  overflow : hidden;

  @media screen and (orientation: portrait) {
    max-width: 75vw;
    font-size: 2.5vh;
  }
`;

const AboutRead = styled.a`
  color: #f53b4d;
  font-size: 1vw;
  font-weight: 300;
  transform: translateY(2.5vh);
  cursor: pointer;

  @media screen and (orientation: portrait) {
    font-size: 2.75vh;
  }
`;

const AboutNumbers = styled.div`
  width: 65vw;
  height: 40vh;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  justify-items: center;
  align-items: center;
  transform: translateX(-3vw);

  @media screen and (orientation: portrait) {
    width: 100vw;
    height: 80vh;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(4, 1fr);
  }
`;

const AboutNumbersMain = styled.div`
  width: 19vw;
  height: 4vw;
  display: flex;

  @media screen and (orientation: portrait) {
    width : 36vh;
    height : 8vh;
    margin-right : 15vw;
  }
`;

const AboutNumbersText = styled.div`
  width: 14vw;
  height: 4vw;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(2, 1fr);
  align-items: center;

  h2 {
    color: #f53b4d;
    margin: 0;
    padding-left: 1vw;
    font-size: 1.5vw;
  }

  h3 {
    color: gray;
    margin: 0;
    padding-left: 1vw;
    font-weight: 400;
    font-size: 1.3vw;
  }

  @media screen and (orientation: portrait) {
    width: 36vh;
    height: 8vh;

    h2 {
      font-size: 3vh;
    }

    h3 {
      font-size: 2.3vh;
    }
  }
`;

const Icon = styled.h1`
  margin: 0;
  max-width: 4vw;
  font-size: 2.75vw;
  color: grey;
  text-align: center;

  @media screen and (orientation: portrait) {
    max-width: 25vh;
    width : 14vh;
    font-size: 6vh;
  }
`;

export default About;
